import api from "../axios";

export const ClientProfileApi = (data) => api.get("user/profile", data);
export const ClientUpdateProfileApi = (data) =>
  api.patch("user/update-profile", data);
export const getCustomersSavedCards = (data) =>
  api.get("user/get-payment-methods", data);
export const deleteUser = (data) => api.delete(`auth/user/delete/${data}`);
export const saveSettings = (data) => api.post("user/save-setting", data);
export const ClientContactUs = (data) =>
  api.post("user/write-contactmsg", data);
export const ClientFavEventApi = (data) => api.get("user/favorites", data);
export const ClientPastPurchaseApi = (data) =>
  api.get("/user/pastpurchased", data);
export const addToFavorites = (data) => api.put(`event/like`, data); // Kept here as it's user action? Revisit if it belongs in Event
export const addToNewsLetter = (data) =>
  api.post("/user/add-to-newsletter", data);
export const GetInstagramPosts = (data) =>
  api.get("/user/get-insta-posts", data);
export const sendIcsFile = (data) => api.post("/user/addtocalender", data);
